// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","cityName":"create-qr-code-modal_cityName__ooq3H"};